@if (facade.lombard$ | async; as lombard) {
  <div class="container-fluid spacer-top-navigation">
    <div class="container">
      @if (lombard.lombardDataStatus === 'INITIAL') {
        <lombard-initial data-zid="lombard-initial" />
        <lombard-faqs />
        <lombard-legal />
      } @else {
        <lombard-status data-zid="lombard-status" />
      }
    </div>
  </div>
}
